"use client";

import { Button, Text } from "@pamperedchef/design-system";

import type { Locale } from "@/domain/catalog/product";

import { useListingProducts } from "../useListingProducts";
import * as styles from "./PlpResultsToolbar.module.scss";

export interface PlpResultsToolbarProps {
	locale: Locale;
}

export function PlpResultsToolbar({
	locale
}: PlpResultsToolbarProps): JSX.Element {
	const { products, isInitialLoad } = useListingProducts(locale);
	const count = products.length;

	return (
		<div className={styles["toolbar"]} data-component="PlpResultsToolbar">
			<Text tag="span" styledAs="smr" data-count={count}>
				{isInitialLoad
					? ""
					: `${count} ${count === 1 ? "Item" : "Items"}`}
			</Text>
			<Button kind="secondary" size="sm">
				Sort By: Relevance
			</Button>
		</div>
	);
}
